import { observer } from 'mobx-react';
import { storeKrunica } from '../store/KrunicaStore';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Tooltip, IconButton } from '@mui/material';

function Povratak({ povratak }) {
  const { zrno, povratakNaPocetak } = storeKrunica;
  if (zrno !== povratak) return null;

  return (
    <Tooltip title="Povratak na početak Krunice" className="povratak">
      <IconButton
        onClick={() => {
          povratakNaPocetak();
        }}
        sx={{ backgroundColor: '#FFE100' }}
      >
        <RestartAltIcon fontSize="large" />
      </IconButton>
    </Tooltip>
  );
}

export default observer(Povratak);
